import { render, staticRenderFns } from "./ChannelManager.vue?vue&type=template&id=1b583738&scoped=true&lang=pug"
import script from "./ChannelManager.vue?vue&type=script&lang=js"
export * from "./ChannelManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b583738",
  null
  
)

export default component.exports